// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__3FICh","tick":"styles_tick__LqH74"};